import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTestinglibraryComponent } from './simple-icons-testinglibrary.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTestinglibraryComponent ],
    exports:      [ SimpleIconsTestinglibraryComponent ],
    bootstrap:    []
})
export class SimpleIconsTestinglibraryModule {}
